import React from "react";
import {Typography} from "@material-ui/core";
import {Copyright} from "@material-ui/icons";

function Footer(){
	return (
		<Typography color="textSecondary"  align="center"><Copyright fontSize="small"/> 2021 QuickCoder. All Rights Reserved. </Typography>
	);
}

export default Footer;